(()=>{
if(window.vfStoryLoaded)return;
window.vfStoryLoaded=true;
let opener=null,observer=null;
function init(){
 observer?.disconnect();
 const nav=[...document.querySelectorAll('.story-jump a')];
 const active=id=>nav.forEach(a=>{if(a.hash==='#'+id)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')});
 if('IntersectionObserver'in window){observer=new IntersectionObserver(entries=>{const visible=entries.filter(e=>e.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top);if(visible[0])active(visible[0].target.id)},{rootMargin:'-150px 0px -45% 0px',threshold:0});document.querySelectorAll('[data-story-anchor]').forEach(s=>observer.observe(s))}
 document.querySelectorAll('[data-story-contact-dialog]').forEach(dialog=>{
  if(dialog.dataset.initialized)return;dialog.dataset.initialized='true';
  dialog.addEventListener('close',()=>{if(opener?.isConnected)opener.focus()});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});
 });
}
document.addEventListener('click',event=>{
 const close=event.target.closest('[data-story-close]');if(close){close.closest('dialog')?.close();return}
 const button=event.target.closest('[data-story-contact]');if(button){event.preventDefault();const dialog=document.querySelector('[data-story-contact-dialog]');if(dialog){opener=button;dialog.showModal()}}
 const topic=event.target.closest('.story-jump a');if(topic){document.querySelectorAll('.story-jump a').forEach(a=>a.removeAttribute('aria-current'));topic.setAttribute('aria-current','location')}
});
document.addEventListener('shopify:section:load',init);
document.addEventListener('shopify:section:unload',init);
document.addEventListener('shopify:block:select',event=>{const details=event.target.closest('.value-list details');if(details)details.open=true});
init();
})();
